<template>
    <v-container fluid pa-0 ma-0 style="height: 90px; width: 90px;" v-demo-show="{event:'welcome.pause', show:true}">
        <v-row justify="center" align="center">
            <v-card v-ripple
                    tile
                    @click="pauseJourney()"
                    height="90"
                    width="90"
                    color="rgba(255,255,255,0.2)"
                    class="d-flex"
            >
                <v-row justify="center" align="center">
                    <v-icon size="42">{{ pausedOverlayState ? 'mdi-play-circle-outline' : 'mdi-pause-circle-outline' }}</v-icon>
                </v-row>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
    import applicationEventHub from "../../../events/applicationEventHub";
    export default {
        name: "JourneyControl",
        computed: {
            pausedOverlayState() {
                return this.$store.state.journey.paused;
            }
        },
        data: () => ({
            overlay: false
        }),
        methods: {
            pauseJourney() {
                this.$store.dispatch('journey/toggleJourneyPauseState', !this.pausedOverlayState);
                applicationEventHub.journeyPaused();
            }
        }
    }
</script>

<style scoped>

</style>